module.exports = __webpack_public_path__ + "img/edge_divers_taxi.ae127d5b.svg";